// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layout-module--layoutWrapper--H0wBR"};